exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1xEXJjHgGXQIA_{display:flex;flex-direction:row}._1xEXJjHgGXQIA_ li{margin-top:2px;margin-right:6px}._1xEXJjHgGXQIA_ li:first-of-type{margin-right:4px}._1xEXJjHgGXQIA_ li:first-of-type img{width:21px}._1xEXJjHgGXQIA_ li,._1xEXJjHgGXQIA_ li a{width:24px;height:24px}._1xEXJjHgGXQIA_ li a{display:flex;align-items:center}", ""]);

// exports
exports.locals = {
	"socialShareLinksList": "_1xEXJjHgGXQIA_"
};